import { useTransformerDrag } from './gizmo-drag'
import { BoundingBox } from './math'
import { Size, TransformerState } from './state'

const edges = [
	// Top
	{ orientation: 'horizontal' as const, corner: 'topLeft' as const, origin: 'top left' },
	// Bottom
	{ orientation: 'horizontal' as const, corner: 'bottomLeft' as const, origin: 'bottom left' },
	// Left
	{ orientation: 'vertical' as const, corner: 'topLeft' as const, origin: 'top left' },
	// Right
	{ orientation: 'vertical' as const, corner: 'topRight' as const, origin: 'top left' },
] as const

export function TransformerGizmoBorder({
	boundingBox,
	state,
	size,
	enableSnapping,
}: {
	boundingBox: BoundingBox
	state: TransformerState
	size: Size
	enableSnapping: boolean
}) {
	const { handleDragStart } = useTransformerDrag({ enableSnapping })

	return (
		<>
			{edges.map(({ orientation, corner, origin }, i) => {
				const isHorizontal = orientation === 'horizontal'
				const pos = boundingBox[corner]

				return (
					<div
						key={i}
						className="absolute pointer-events-auto cursor-grab"
						style={{
							width: isHorizontal ? size.width * state.scale : '8px',
							height: isHorizontal ? '8px' : size.height * state.scale,
							transformOrigin: origin,
							transform: `translate(${pos.x - (isHorizontal ? 0 : 4)}px, ${
								pos.y - (isHorizontal ? 4 : 0)
							}px) rotate(${state.rotation}rad)`,
						}}
						onMouseDown={handleDragStart}
						data-prevent-focus-loss
					>
						{isHorizontal
							? (
								<div className="bg-[lime] absolute left-0 right-0 top-1/2 h-[1px] -translate-y-1/2 pointer-events-none" />
							)
							: (
								<div className="bg-[lime] absolute top-0 bottom-0 left-1/2 w-[1px] -translate-x-1/2 pointer-events-none" />
							)}
					</div>
				)
			})}
		</>
	)
}
